<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" style="padding-top: 70px">
      <div class="fixed-top">
        <v-tabs class="hidden-sm-and-down" optional background-color="white">
          <v-tab
            to="/"
            active-class="red accent-4 white--text"
            class="font-weight-bold"
            min-width="96"
          >
            Home
          </v-tab>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="red accent-4 white--text"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Caregiver/ MDW/ Confinement Nanny
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/services" left> Our services </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/biodata"> Biodata </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="red accent-4 white--text"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Local & Foreign Recruitment
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/job-post"> List of Job Postings </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/jobseekers"> Jobseekers or employers </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="red accent-4 white--text"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Courses
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/courses"> Courses </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/course-modules"> Course Modules </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tab
            to="/about-us"
            active-class="red accent-4 white--text"
            class="font-weight-bold"
            min-width="96"
          >
            About us
          </v-tab>
          <v-tab
            to="/faq"
            active-class="red accent-4 white--text"
            class="font-weight-bold"
            min-width="96"
          >
            FAQ
          </v-tab>

          <v-tab
            to="/contact-us"
            active-class="red accent-4 white--text"
            class="font-weight-bold"
            min-width="96"
          >
            Contact Us
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer"),
  },

  data: () => ({
    drawer: null,
    items: [
      "Home",
      "About Us",
      "Services",
      "Biodata",
      "Job Postings",
      "Job Seeker",
      "Courses",
      "Course Modules",
      "FAQ",
      "Contact Us",
    ],
  }),
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

    .v-tab
      &::before
        display: none
</style>

<style scoped>
#home-app-bar {
  position: sticky;
}
</style>
